import React, { useState } from "react";
import "./css/Menu.css"; // Custom CSS file
import { useNavigate } from "react-router-dom";

const categories = {
  "Appetizer": [
    { title: "Beef Sticks w. Teriyaki Sauce(4)", description: null, price: "$5.75" },
    { title: "Chicken Lettuce Wrap", description: null, price: "$7.95" },
    { title: "Crab Rangoon(5)", description: null, price: "$3.50" },
    { title: "Egg Roll(2)", description: null, price: "$3.25" },
    { title: "🌶️Hot Spicy Chicken Wings(8)", description: null, price: "$8.50" },
  ],
  Salad: [
    { title: "Chicken Salad", description: null, price: "$5.75" },
    { title: "Edamame", description: null, price: "$4.95" },
    { title: "Vegetable Salad", description: null, price: "$4.25" },
  ],
  Soup: [
    {
      title: "Chicken W. Corn Soup(2)",
      description: null,
      price: "$7.50",
    },
    {
      title: "TS1. Chicken Coconut Soup (Tom Kha Gai)",
      description:
        "Traditional Thai chicken soup with mushrooms, galangal, lime juice, coconut milk, and exotic spices.",
      price: "$3.85",
    },
    {
      title: "TS2. 🌶️ Spicy Hot & Sour Shrimp Soup (Tom Yum Koong)",
      description:
        "Thailand's most favorite spicy shrimp soup with lemongrass and mushrooms.",
      price: "$4.95",
    },
    { title: "Vegetable Soup(2)", description: null, price: "$5.75" },
    { title: "Seafood Soup(2)", description: null, price: "$7.95" },
  ],
  Pork: [
    { title: "Moo Shu Pork", description: null, price: "$10.95" },
    { title: "🌶️Pork W. Garlic Sauce", description: null, price: "$10.95" },
    { title: "Pork W. String Bean", description: null, price: "$10.95" },
    { title: "Sweet & Sour Pork", description: null, price: "$10.95" },
    { title: "🌶️Twice Cooked Pork", description: null, price: "$11.75" },
  ],
  Vegetable: [
    { title: "🌶️Broccoli W. Garlic Sauce", description: null, price: "$9.95" },
    { title: "🌶️Eggplant W. Garlic Sauce", description: null, price: "$10.75" },
    { title: "Home Style Bean Curd", description: null, price: "$10.75" },
    { title: "Moo Shu Vegetable", description: null, price: "$10.75" },
    { title: "Sauteed String Bean", description: null, price: "$10.75" },
  ],
};


const MenuComponent = () => {
  const [activeCategory, setActiveCategory] = useState("Appetizer");
  const navigate = useNavigate()

  return (
    <div className="d-flex menu-layout">
      {/* Sidebar */}
      <div className="menu-sidebar bg-dark text-white p-4">
        <h5 className="text-gold text-center mb-4">━ Our MENU ━</h5>
        <div className="menu-links text-center">
          {Object.keys(categories)?.map((category) => (
            <p
              key={category}
              className={`menu-link ${activeCategory === category ? "active" : ""}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </p>
          ))}
        </div>
        <div className="text-center mt-4">
          <button className="btn btn-outline-light"
            onClick={() => navigate("/menu")}
          >VIEW ALL MENU</button>
        </div>
      </div>

      {/* Main Content */}
      <div className="menu-content flex-grow-1 p-4">
        {categories[activeCategory]?.map((item, index) => (
          <div key={index} className="menu-item mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="mb-0">{item.title}</h6>
              <span className="menu-price">{item.price}</span>
            </div>
            <p className="menu-description text-muted mb-0">{item.description}</p>
          </div>
        ))}
      </div>


    </div>
  );
};

export default MenuComponent;
